import { PeriodType } from "../types";
import { httpClient } from "./httpClient";

type SurchargeType = "sms" | "mms";

type GetSurchargeRecordsArgs = {
  type: SurchargeType;
  periodType: PeriodType;
  startDate?: string;
  endDate?: string;
};

export async function getSurchargeRecords({
  type,
  periodType,
  startDate,
  endDate,
}: GetSurchargeRecordsArgs) {
  const periodTypeParam = periodType.toLocaleLowerCase();
  const url = `/surcharges/${type}/${periodTypeParam}`;

  const response = await httpClient(url, {
    method: "GET",
    parameters: {
      start_date: startDate,
      end_date: endDate,
    },
  });

  return response.body;
}
